import React, { useCallback, useMemo, useState } from 'react';

import {
	Button,
	Space,
	Modal,
	ModalTitle,
    TaskList,
	extractTasks,
} from '@components';
import { cloneDeep } from 'lodash';
import './SendTasksModal.scss';
import { SummaryBlock } from '@api';

interface SendTasksModalProps {
	closeModal: () => void,
	summaryBlocks: SummaryBlock[],
    onUpdateSummaryData: (updatedBlocks: SummaryBlock[]) => void,
	onComplete: (sendTasks: boolean, selectedTasks: string[]) => void,
    canEditResume: boolean,
}

function SendTasksModal(props: SendTasksModalProps): JSX.Element {
	const {
		closeModal,
        summaryBlocks,
        onUpdateSummaryData,
        onComplete,
        canEditResume,
	} = props;

	const hideSendTasks = true;
	const tasks = useMemo(() => extractTasks(summaryBlocks, hideSendTasks), [summaryBlocks, hideSendTasks]);
	const [selectedTasks, setSelectedTasks] = useState<string[]>(tasks.map(t => t.item.id));

	const changeSelection = useCallback((changeItemId: string) => {
		if (selectedTasks.includes(changeItemId)) {
			const changedSelectedItems = selectedTasks.filter(it => it != changeItemId);
			setSelectedTasks(changedSelectedItems);
		} else {
			const changedSelectedItems = cloneDeep(selectedTasks);
			changedSelectedItems.push(changeItemId);
			setSelectedTasks(changedSelectedItems);
		}
	}, [selectedTasks, setSelectedTasks]);
	
	const headerView = useMemo((): JSX.Element => {
		return (
			<div className="resume-modal__header">
				<ModalTitle onClose={closeModal}>
                    Задания на исполнение
				</ModalTitle>
			</div>
		);
	}, [closeModal]);

	
	const footerView = useMemo(() => {
		const handleSendAndComplete = () => {
			onComplete(true, selectedTasks);
			closeModal();
		};
	
		const handleCompleteWihtoutSending = () => {
			onComplete(false, selectedTasks);
			closeModal();
		};

		return (
			<Space>
				<Button theme="primary" onClick={handleSendAndComplete} disabled={!tasks || !tasks.length || !selectedTasks || !selectedTasks.length}>
                    Отправить и звершить
				</Button>
                <Button onClick={handleCompleteWihtoutSending}>
                    Завершить без отправки
				</Button>
				<Button onClick={closeModal}>
					Отменить
				</Button>
			</Space>
		);
	}, [closeModal, onComplete, tasks, selectedTasks]);


	return summaryBlocks && (
		<Modal
			className="tasks-modal"
			header={headerView}
			footer={footerView}
			isOpen
		>
			<div className="tasks__content">
                <TaskList
					allowSelection={true}
					selectedTasks={selectedTasks}
					onChangeSelection={changeSelection}
					tasks={tasks}
					onUpdateSummaryData={onUpdateSummaryData}
					className="modal-task-list"
                    canEditResume={canEditResume}
					summaryBlocks={summaryBlocks}
				/>
			</div>
		</Modal>
	);
}

export {SendTasksModal};